<router-outlet></router-outlet>
<app-redirect></app-redirect>
<ngx-ui-loader></ngx-ui-loader>
<ng-container *ngIf="chatFab" [ngComponentOutlet]="chatFab"></ng-container>
<flow-sync-document-viewer-v2
    [isOpen]="viewerState.isOpen"
    [documentUrl]="viewerState.documentUrl"
    [documentName]="viewerState.documentName"
    (closed)="closeViewer()">
</flow-sync-document-viewer-v2>
